"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styles = require("@eig-builder/core-ui/styles");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var styles = function styles(theme) {
  return {
    root: {
      paddingTop: "".concat(theme.spacing(3), "px"),
      paddingBottom: "".concat(theme.spacing(3), "px")
    }
  };
};

var FieldWrapper = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(FieldWrapper, _Component);

  var _super = _createSuper(FieldWrapper);

  function FieldWrapper() {
    var _this;

    (0, _classCallCheck2["default"])(this, FieldWrapper);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.hasAppendLabel = function () {
      return _this.props.data && _this.props.data.appendLabel;
    };

    return _this;
  }

  (0, _createClass2["default"])(FieldWrapper, [{
    key: "getClassName",
    value: function getClassName() {
      var gridClass = this.props.styleSettings && this.props.styleSettings.grid;
      return (0, _classnames["default"])('core-property-editor-components-fields-field', 'd-flex', this.props.type && this.props.type.toLowerCase(), this.props.className, this.props.classes.root, {
        gridClass: gridClass,
        'col-12': !gridClass && !this.props.noCol12,
        hasAppendLabel: this.hasAppendLabel(),
        isReadOnlyField: this.props.readOnly
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: this.getClassName()
      }, this.props.children);
    }
  }]);
  return FieldWrapper;
}(_react.Component);

FieldWrapper.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]),
  styleSettings: _propTypes["default"].object,
  readOnly: _propTypes["default"].bool,
  type: _propTypes["default"].string,
  data: _propTypes["default"].object,
  noCol12: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  classes: _propTypes["default"].object
};

var _default = (0, _styles.withStyles)(styles)(FieldWrapper);

exports["default"] = _default;